import "./ServiceBenefits.css";

const ServiceBenefits = ({ data }) => {
  return (
    <section className="service-benefits">
      <div className="benefits-container">
        <div className="benefits-heading">
          <span className="section-tag-benefits">WHY CHOOSE OUR COURTS</span>

          <h2>Built For Performance, Safety & Durability</h2>

          <p>
            Every Sports Court is engineered using premium international sports
            flooring systems to ensure long-lasting performance and player
            safety.
          </p>
        </div>

        <div className="benefits-grid">
          {data.benefits.map((item, index) => (
            <div className="benefit-card" key={index}>
              <div className="benefit-icon">🏀</div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceBenefits;
